// extracted by mini-css-extract-plugin
var _1 = "tFrJ8";
var _2 = "lccWD";
var _3 = "FX83h";
export { _1 as "base", _2 as "header", _3 as "main" }
